// extracted by mini-css-extract-plugin
export default {"receiver_wrap":"style_receiver_wrap__zThve","receiver_item":"style_receiver_item__snReM","receiver_item_idx":"style_receiver_item_idx__jYvc5"};